<template>
    <div class="xtxx">
       <div class="search">
            <van-search
                v-model="search"
                shape="round"
                placeholder="请输入搜索关键词" clearable @search="onSearch"
            />
        </div>
       
        <div class="biaoqian">
            <van-pull-refresh v-model="refreshing1" @refresh="onRefresh1" >
                <van-list
                    v-model="loading1"
                    :finished="finished1"
                    finished-text="没有更多了"
                    @load="onLoad1"
                >
                    <div class="pj" v-for="(item,index) in list1" :key="index" @click="goxq(item.id,tp,'tscz')">
                        <!-- <img src="../../assets/tsbx/ls.png" alt=""> -->
                        <div class="xq">
                            <span v-if="tp=='ts'"> <span class="blue">[{{item.complaintType}}]</span>{{item.complaintTitle}}</span>
                            <span v-if="tp=='bx'">{{item.repairType}}</span>
                            <span>{{item.createdDate}} </span>
                            <!-- <button class="dpj">{{item.status}}</button> -->
                            <!-- <button class="dpj orange">{{item.status}}</button> -->
                        </div>
                    </div>
                </van-list>
            </van-pull-refresh>

        </div>
    </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
    data() {
        return {
            tp:'',
            search:'',
            active:'',
            list1:[],
            list2:[],
            loading1: false,
			loading2: false,
            finished1: false,
			finished2: false,
            refreshing1: false,
			refreshing2: false,
            currpage1:0,//投诉页码
            currpage2:0,//报修页码
        }
    },
    computed: {
 	...mapState(['userInfo','identity','houseId','isactive']),
 },
    mounted() {
        this.tp = this.$route.query.tp
            this.onLoad1()
        //    this.reload()
        

    },
    methods: {

        			onSearch(val) {
                        this.list1=[],
                        this.loading1=false,
                        this.finished1=false,
                        this.refreshing1=false,
                        this.currpage1=0

        // this.onLoad1()
        this.getdata('ts')
			},
        goxq(id,type,tscz){
            if(type=='bx'){
                this.$router.push({ path: "/tsbx/list/xq", query: {id:id,type:2,pj:true} });
            }else{
                if(this.$route.query.nobtn){
                    this.$router.push({ path: "/tsbx/gdxq", query: {id:id,type:1} });//去综合查询工单详情，没按钮
                }else{
                    if(tscz=='tscz'){
                        this.$router.push({ path: "/tsbx/gdxq", query: {id:id,type:1} });//投诉处置工单详情,有按钮

                    }else{
                        this.$router.push({ path: "/tsbx/gdxq", query: {id:id,type:2} });//工单详情,有按钮

                    }

                }
            }
            
        },
        // goxq1(id){
        //     this.$router.push({ path: "/tsbx/gdxq", query: {id:id,type:1,nobtn:false} });//去综合查询工单详情，有按钮
        // },
        getdata(name){
            if(name == 'ts'){

                let data = new FormData();
                 var jsonData = {};
                     jsonData = {
                         pageNum:this.currpage1,
                         pageSize:15,
                         complaintTitle:this.search
                 }
                       for (let key in jsonData) {
         data.append(key, jsonData[key]);
       }

                this.$axios.post('/api/v1/complaint/sysList/gdcl', data).then(res => {
          if (this.currpage1 == 0) {
            this.list1 = res.data;

          } else {
            if (res.data) {
              this.list1 = this.list1.concat(res.data);
            }
          }

          this.loading1 = false;
          this.refreshing1 = false;

          if (!res.data|| res.data.length < 10) {
            this.finished1 = true;
          } else {
            this.currpage1++;
            this.finished1 = false;
          }
                });
            }else if(name == 'bx'){
                this.$axios.get('/api/v1/repair/list', {//报修工单list
                    params: {
                        status:"评价",
                        pageNum:this.currpage1,
                        pageSize:15,
                        houseId:this.houseId,
                    }
                }).then(res => {
                    this.list1.push(...res.data);
                    this.currpage1++;
                    this.loading1 = false;
                    if (this.list1.length >= res.total) {
                        this.finished1 = true;
                    }
                });
            }
            
        },
        onLoad1(){
           if (this.refreshing1) {
				// 清空列表数据
				this.currpage1 = 0;
				this.list1 = [];
				this.refreshing1 = false;
           }
           this.getdata(this.$route.query.tp)
		   
        },
        onRefresh1() {
			  this.finished1 = false;
			  // 重新加载数据
			  // 将 loading 设置为 true，表示处于加载状态
			  this.loading1 = true;
			  this.onLoad1();
        },


        
    },
}
</script>
<style lang="less" scoped="scoped">
	.orange{
		color: rgb(240, 182, 49);
	}
	.blue{
		color: #28aff6;
	}
    .xtxx{
        height: calc(100% - 50px);
        width: 100%;
        display: flex;
        background-color: #fff;
        flex-direction: column;
        align-items: center;
        .van-tabs{
            height: 100%;
        }
        .van-pull-refresh{
            height: 100%;
        }
        .van-tab__pane{
            height: 100%;
        }
        .van-tabs__content{
            height: calc(100vh - 140px);
        }
        .van-pull-refresh__track{
            overflow: hidden;
            overflow-y: scroll;
        }
        .wdxx{
            margin: 26px 10px 26px 10px;
        }
        .biaoqian{
            height: 100%;
            width: 100%;
        }
        .xtxxc{
            width: calc(100% - 6%);
            height: 100%;
        }
        .pj{
            display: flex;
            width: 94%;
            // height: 100px;
			padding:14px 10px ;
            border-radius: 10px;
            display: flex;
            align-items: center;
            box-shadow: 0px 0px 5px #e6e6e6;
            margin-top: 10px;
            img{
                margin-left: 2%;
                height: 80px;
                width: 80px;
            }
            .xq{
                height: 100%;
                width: 100%;
                margin-left: 2%;
                display: flex;
                flex-direction: column;
                position: relative;
                span{
                    width: 70%;
                }
                span:nth-child(1){
                    font-weight: bold;
                }
                span:nth-child(2){
                    margin-top: 5px;
                    color: #999999;
                }
                // .dpj{
                //     height: 25px;
                //     top: calc(50% - 15px);
                //     position: absolute;
                //     right: 2%;
                //     border: 1px solid #00d2ff;
                //     color: #00d2ff;
                //     background-color: transparent;
                //     border-radius: 30px;
                //     font-size: 15px;
                // }
                .dpj{
                    height: 25px;
                    top: calc(50% - 15px);
                    position: absolute;
                    right: 2%;
                    border: 1px solid rgb(240, 182, 49);
                    color: rgb(240, 182, 49);
                    background-color: transparent;
                    border-radius: 30px;
                    font-size: 15px;
                }
            }
        }
        .search{
            width: 100%;
            height: 50px;
            display:block;
        }
        .van-tabs__line{
            background-color: #28aff6;
            width: 90px;
            border-radius: 5px;
        }
        .van-list{
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        .wdxxitem{
            color: white;
            margin-top: 20px;
            font-weight: 600;
            height: 70px;
            width:90%;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #b7b7b7;
            border-radius: 10px;
        }
        ::-webkit-scrollbar{
            display: none;
        }
    }
</style>